<template>
  <div class="backimg">
    <v-card class="mx-auto" max-width="600" height="100%">
      <v-container style="height: 100%; display: flex; flex-direction: column; justify-content: space-between;">
        <div>
          <v-img :src="require('../assets/YM_logo.jpg')" contain height="10vh" />
        </div>
        <form @submit.prevent="onSubmit">
          <div>
            <v-row>
              <v-col cols="12">
                <v-text-field label="ID" variant="outlined" append-inner-icon="mdi mdi-account-outline"
                  v-model="users.id"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="전화번호" hide-details="auto" variant="outlined" append-inner-icon="mdi mdi-cellphone"
                  v-model="users.pw"></v-text-field>
              </v-col>
              <v-col>
                <v-btn block class="login mb-8" color="white" size="large" variant="tonal" type="submit">
                  로그인
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </form>
        <div>
          <v-card color="surface-variant" variant="tonal">
            <v-card-text class="px-3 py-1 info">
              <div>
                <span class="mdi mdi-information"></span> 안내사항
              </div>
              <div v-for="(item, index) in info" :key="index">
                {{ item }}
              </div>
            </v-card-text>
          </v-card>
        </div>
        <div class="DividerArea"></div>
        <div class="botInfo">
          <v-card-text class="text-medium-emphasis text-caption">
            <div v-for="(item, index) in footer" :key="index">
              {{ item }}
            </div>
          </v-card-text>
        </div>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import { defineComponent, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import Swal from 'sweetalert2/dist/sweetalert2'

import api from '@/api/index'

export default defineComponent({
  name: 'LoginForm',
  setup() {
    const info = ref([]);
    const footer = ref([]);

    const load = async () => {
      api.get('/api/infoflawcom').then((res) => {
        for(var i = 1; i <= 5; i++)        {
          info.value.push(res.data[0]["txtInfo" + i])
        }
        for(var j = 1; j <= 3; j++)        {
          footer.value.push(res.data[0]["txtFooter" + j])
        }
      })
    }
    load();

    const store = useStore()
    const users = reactive({
      id: '',
      pw: '',
    })
    const onSubmit = () => {
      if (users.id && users.pw) {
        store.dispatch('login', users)
        .then(() => {
          const auth = store.getters['getData']
          if (auth.login == 'failed') {
            store.commit('resetData')
          }
        })
      } else {
        Swal.fire({
          title: '알림',
          text: '아이디 및 비밀번호를 입력하세요.',
          showConfirmButton: true,
          confirmButtonText: '확인',
          showCancelButton: false,
          allowOutsideClick: false,
          customClass: {
            title: 'fd',
            htmlContainer: 'f1',
            confirmButton: 'f2',
          },
        })
      }
    }
    return {
      onSubmit,
      users,
      info,
      footer
    }
  },
})
</script>
<style scoped>
.backimg {
  height: 100%;
  width: 100%;
  background-image: url('../assets/login_background.png');
  background-size: cover;
}

.login {
  background: rgb(205, 37, 66);
  width: 100%;
  height: 50px;
}
</style>
<style>
.swal2-popup {
  width: 330px !important;
}

.fd {
  margin: 0 !important;
  padding: 16px 16px !important;
  font-size: 20px !important;
  text-align: initial;
}

.f1 {
  margin: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 16px !important;
  overflow: initial;
  font-size: 16px !important;
  text-align: initial;
}

.f2 {
  display: block !important;
  font-size: 15px !important;
}

.DividerArea {
  height: 32vh;
}

.info>div:nth-child(1) {
  color: rgb(73, 82, 136);
  font-weight: bold;
}

.info>div:not(:nth-child(1)) {
  font-weight: bold;
  font-size: 12px;
}

.botInfo>div {
  font-weight: 700;
  text-align: center;
  font-size: 12px;
}
</style>